/**
 * Scale for `ai-logo-simple` after the glyph was tightened to the viewBox.
 * Previous asset had ~25% inset on each side (glyph ≈ 50% of the box). The
 * tightened asset fills ~91% of the viewBox; scaling to ~55% restores the old
 * visual weight while keeping the sharper full-bleed paths.
 */
export const AI_LOGO_SIMPLE_GLYPH_SCALE = 0.55;

/** CSS size string for width/height when the parent defines the icon box. */
export const AI_LOGO_SIMPLE_GLYPH_SIZE = `${AI_LOGO_SIMPLE_GLYPH_SCALE * 100}%`;

/**
 * Slightly larger glyph for AILauncher / Overview card buttons — still inset from
 * the full-bleed asset, but more prominent than the circular avatar/FAB treatment.
 */
export const AI_LOGO_SIMPLE_LAUNCHER_GLYPH_SCALE = 0.72;
export const AI_LOGO_SIMPLE_LAUNCHER_GLYPH_SIZE = `${AI_LOGO_SIMPLE_LAUNCHER_GLYPH_SCALE * 100}%`;

/** Path `d` from `ai-logo-simple.inline.svg` — for CSS masks (gradient fills). */
export const AI_LOGO_SIMPLE_PATH_D =
  'M57.4213 5.913c3.0021-7.884 14.1553-7.884 17.1574 0l8.3448 21.9151a36.72 36.72 0 0 0 21.2485 21.2484l21.915 8.3448c7.884 3.0021 7.884 14.1553 0 17.1574l-21.915 8.3448a36.719 36.719 0 0 0-21.2485 21.2485l-8.3448 21.915c-3.0021 7.884-14.1554 7.884-17.1574 0l-8.3448-21.915a36.719 36.719 0 0 0-21.2484-21.2485L5.913 74.5787c-7.884-3.0021-7.884-14.1553 0-17.1574l21.9151-8.3448a36.72 36.72 0 0 0 21.2484-21.2484z';

/** CSS mask that paints the ai-logo-simple glyph (use with `background: palette.ai.gradient`). */
export const AI_LOGO_SIMPLE_MASK = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132 132"><path fill="black" d="${AI_LOGO_SIMPLE_PATH_D}"/></svg>`,
)}")`;
